module.exports = __webpack_public_path__ + "img/partner_logo16.d32dccba.png";